/**
 * `/konto/google` — where Google's consent page sends the browser back (calendar-sync-requirements
 * R10). The backend allows exactly this page as the redirect.
 *
 * Under `_shell`, not beside `reset-password`: the POST it makes is the signed-in trainer's, so the
 * session guard is the one every screen inherits. The TRAILING UNDERSCORE on `konto_` keeps it out
 * of `/konto`'s route as a child — that route is a leaf with no `<Outlet/>`
 * (`_shell.klienci.$clientId_.plan.$assignmentId.tsx` explains the same opt-out).
 *
 * No `validateSearch`: `code` and `state` are read once from the address by the slice and scrubbed
 * from it, and are never put into router state.
 */

import { createFileRoute } from '@tanstack/react-router';

import { GoogleCalendarReturnScreen } from '~/pages/account';

export const Route = createFileRoute('/_shell/konto_/google')({
  component: GoogleCalendarReturnScreen,
});
